// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"b368cc7c","383":"f16fc7f0"}[chunkId] + ".chunk.js";
};